<template>
  <div class="scheduled-events text-dark">
    <h2 class="marg-5-bottom">{{ i18n[locale].scheduled_events }} "{{ subject.name }}"</h2>
    <Loader bg-color="#f6f9fc" v-if="isLoading"></Loader>
    <div v-else>
      <p class="text-explainer" v-if="sortedEvents.length < 1">{{ i18n[locale].no_scheduled_events }}</p>
      <table class="scheduled-events__table" v-else>
        <thead>
          <tr>
            <th>{{ i18n[locale].date }}</th>
            <th>{{ i18n[locale].weekday }}</th>
            <th>{{ i18n[locale].time }}</th>
            <th>{{ i18n[locale].calendars }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="event in sortedEvents" :key="event.event_id">
            <td>
              <span class="subject-event" :style="{'backgroundColor': subject.color}">{{ event.v_date }}</span>
            </td>
            <td class="text-capitalize">{{ event.v_weekday }}</td>
            <td>{{ event.v_time }}</td>
            <td class="text-greyed">{{ event.v_calendars }}</td>
          </tr>
        </tbody>
      </table>
      <p class="scheduled-events__count" v-if="sortedEvents.length > 0">
        {{ sortedEvents.length }} {{ i18n[locale].events_total }}
      </p>
    </div>
  </div>
</template>
<script>
import Loader from '../common/Loader'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import moment from 'moment'

const I18N = {
  da: {
    scheduled_events: 'Skemalagte brikker for',
    no_scheduled_events: 'Der er ingen skemalagte brikker',
    date: 'Dato',
    weekday: 'Ugedag',
    time: 'Tid',
    calendars: 'Kalendere',
    events_total: 'skemalagte brikker i alt'
  },
  en: {
    scheduled_events: 'Scheduled lessons for',
    no_scheduled_events: 'There are no scheduled lessons',
    date: 'Date',
    weekday: 'Weekday',
    time: 'Time',
    calendars: 'Calendars',
    events_total: 'scheduled lessons in total'
  },
  nb: {
    scheduled_events: 'Timeplanlagte brikker for',
    no_scheduled_events: 'Det er ingen timeplanlagte brikker',
    date: 'Dato',
    weekday: 'Ukedag',
    time: 'Tid',
    calendars: 'Kalendere',
    events_total: 'timeplanlagte brikker totalt'
  }
}

export default {
  components: {Loader},
  props: {
    subject: {
      required: true,
      type: Object,
      default: null
    }
  },
  data () {
    return {
      i18n: I18N,
      events: [],
      isLoading: false
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    sortedEvents () {
      return this.events
        .slice()
        .sort((a, b) => moment(a.start).valueOf() - moment(b.start).valueOf())
        .map(event => {
          return {
            ...event,
            v_date: this.formatDate(event.start),
            v_weekday: this.formatWeekday(event.start),
            v_time: this.formatTime(event.start, event.end),
            v_calendars: this.formatCalendars(event.calendars)
          }
        })
    }
  },
  methods: {
    formatDate (datetime) {
      if (!datetime) return ''
      moment.locale(this.locale)
      return moment(datetime).format('L')
    },
    formatWeekday (datetime) {
      if (!datetime) return ''
      moment.locale(this.locale)
      return moment(datetime).format('dddd')
    },
    formatTime (start, end) {
      moment.locale(this.locale)
      const from = start ? moment(start).format('LT') : ''
      const to = end ? moment(end).format('LT') : ''
      return to ? from + ' - ' + to : from
    },
    formatCalendars (calendars) {
      if (!Array.isArray(calendars)) return ''
      const names = calendars
        .map(calendar => calendar && calendar.name)
        .filter(name => name)
      return names.filter((name, index) => names.indexOf(name) === index).join(', ')
    },
    parseEvents (success) {
      if (Array.isArray(success)) return success
      if (typeof success === 'string' && success.length > 0) {
        try {
          const parsed = JSON.parse(success)
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          return []
        }
      }
      return []
    },
    readScheduledEvents () {
      this.isLoading = true
      docendo.eventsBySubjects([this.subject.id], null, null, success => {
        this.events = this.parseEvents(success)
        this.isLoading = false
      }, failure => {
        eventbus.toast = {text: this.$t('vue2.sms.an_error_occured'), success: false}
        this.isLoading = false
      })
    }
  },
  mounted () {
    this.readScheduledEvents()
  }
}
</script>

<style scoped>
.scheduled-events__table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.scheduled-events__table th {
  text-align: left;
  padding: 0.5rem;
  background: #fff;
  border-bottom: 1px solid #ccc;
}

.scheduled-events__table td {
  padding: 0.25rem 0.5rem;
  border-bottom: 1px solid #ccc;
}

.scheduled-events__table tbody tr:hover {
  background: #eee;
}

.subject-event {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  color: #ffffff;
}

.text-capitalize {
  text-transform: capitalize;
}

.text-greyed {
  color: #a2a3a6;
}

.scheduled-events__count {
  color: #a2a3a6;
  margin-top: 0.5rem;
}

.text-explainer {
  font-style: italic;
  color: #a2a3a6;
  padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// SubjectFormScheduledEvents.vue?cbe2367a